import styled from 'styled-components';

import { IconX } from '../../../common/icons/cdl/X';
import { theme } from '../../../common/ui/theme';

interface ToastDismissButtonProps {
    onClick: () => void;
}

const Button = styled.button`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    flex-shrink: 0;
    width: 40px;
    appearance: none;
    background-color: ${theme.colors.negative.emphasis};
    border: none;
    color: ${theme.colors.foreground.onEmphasis};
    cursor: pointer;
    transition: background-color 100ms ease-out;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 1px;
        background-color: ${theme.colors.negative.foreground};
    }

    &:hover {
        background-color: ${theme.colors.negative.foreground};
    }
`;

export const ToastDismissButton = ({ onClick }: ToastDismissButtonProps) => {
    return (
        <Button type="button" onClick={onClick}>
            <IconX width={20} height={20} color={theme.colors.foreground.onEmphasis} />
        </Button>
    );
};
